export const GET_EVENTS_SUCCESS = "getEventsSuccess"
export const CREATE_EVENT_SUCCESS = "createEventSuccess"
export const UPDATE_EVENT_SUCCESS = "updateEventSuccess"
export const SET_LOADER = "setLoader"
export const DELETE_EVENT_SUCCESS = "deleteEventSuccess"